import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Skeleton } from 'antd';
import { ModalCustom } from '$src/components/Modal';
import useStores from '$src/hooks/useStores';
import selectIcon from '$src/utils/selectIcon';
import { devicesWithoutBaseStationFilter, isAstro } from '$src/utils/devices/selectDevices';
import ActionCell from '$src/components/ActionCell';
import { ASTRO_DEVICE_INTERNAL_TYPE } from '$src/utils/devices/constants';
import { eligibilityStatus, monitoringStatus } from '../LocationsTableCard/constants';

import './index.less';

export default function LocationDetailsDialog({ showModal, toggleLocationDetailsDialog, location, ...rest }) {
  const { sessionStore, devicesStore } = useStores();
  const { fetchDevices, devicesInLocation } = devicesStore;
  const devicesWithoutBaseStation = devicesWithoutBaseStationFilter(devicesInLocation);
  const { user } = sessionStore;
  const [fetchingDevices, setFetchingDevices] = useState(true);
  const order = (deviceA, deviceB) => !!deviceB.starkEnrolled - !!deviceA.starkEnrolled;

  useEffect(() => {
    async function getDevices() {
      setFetchingDevices(true);
      await fetchDevices(location.locationId, user?.user_id);
      setFetchingDevices(false);
    }

    if (location) getDevices();
  }, [location, user.user_id, fetchDevices]);

  return (
    <ModalCustom
      title="Location Details"
      data-testid="location-details-dialog"
      className="location-details-dialog modal-wrapper"
      contentTitle={`${location?.locationName} Location Details`}
      width="650px"
      contentMessage={
        <Skeleton active loading={fetchingDevices} paragraph={{ rows: 8 }}>
          <ul>
            <li>
              <b>Name:</b> {location?.locationName}
            </li>
            <li>
              <b>Address:</b> {location?.fullAddress}       
            </li>
            <li>
              <b>City: </b>
              {location?.address.city}
            </li>
            <li className={!location?.eligible ? 'danger' : ''}>
              <b>Eligibility: </b>
              {eligibilityStatus[location?.eligibilityReason] ? eligibilityStatus[location?.eligibilityReason].lg : eligibilityStatus.UNKNOWN.lg}
            </li>
            <li className={!location?.monitoring ? 'danger' : ''}>
              <b>Monitoring: </b>
              {monitoringStatus[location?.monitoringReason] ? monitoringStatus[location?.monitoringReason].lg : monitoringStatus.UNKNOWN.lg}
            </li>
          </ul>
          <div className="location-details-dialog__devices-list__title"> {devicesWithoutBaseStation?.length > 0 ? 'Devices' : 'No Devices'} </div>
          <div className="location-details-dialog__devices-list">
            {devicesWithoutBaseStation?.sort(order).map((device) => (
              <ActionCell
                className={device.starkEnrolled ? 'enrolled' : 'unenrolled'}
                iconName={selectIcon(isAstro(device) ? ASTRO_DEVICE_INTERNAL_TYPE : device.type)}
                type="plain"
                value={!!device.starkEnrolled}
                id={device.doorbotId}
                key={device.doorbotId}
              >
                {device.name}
              </ActionCell>
            ))}
          </div>
        </Skeleton>
      }
      setModalVisible={toggleLocationDetailsDialog}
      visible={showModal}
      handleOk={toggleLocationDetailsDialog}
      maskClosable
      okText="Close"
      {...rest}
    />
  );
}

LocationDetailsDialog.propTypes = {
  showModal: PropTypes.bool.isRequired,
  toggleLocationDetailsDialog: PropTypes.func,
  location: PropTypes.object,
};
